/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './Checkbox.module.css';

const Checkbox = (props) => {
  const { name, onChange, checked, readOnly } = props;
  return (
    <label className={classes.checkbox}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        readOnly={readOnly} />
      <span>{name}</span>
    </label>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

Checkbox.defaultProps = {
  checked: false,
  onChange: () => { },
  readOnly: false,
};
